import { useContext } from 'react'
import { ThemeContext, DARK } from '../providers/ThemeProvider'

const useColorByTheme = (light: string, dark: string) => {
  const { theme } = useContext(ThemeContext)
  return theme === DARK ? dark : light
}

export default useColorByTheme
